export default __webpack_public_path__ + "static/media/headset7.150bcbaa.jfif";